import axios from "axios"
import { clone, objectCamelToSnakeCase, objectSnakeToCamelCase, deleteKeyNullValues } from "@/util/libUtil.js"
import defaultHolidaysForm from "@/util/rrhh/defaultHolidaysForm.js"
import defaultWorkingCalendarForm from "@/util/rrhh/defaultWorkingCalendarForm.js"

const state = {
    isLoading: false,
    
    holidays: [],
    isOpenHolidaysDialog: false,
    isOpenHolidaysForm: false,
    holidaysFormType: "CREATE",
    holidaysForm: clone(defaultHolidaysForm),
    selectedComercial: null,
    rangoDate: null,

    spentHolidays: {
        spent_holidays: 0,
        max_holidays: 0,
        holiday_type: 'Laborables',
    },
    workingCalendarObj: {
        workingCalendar: [],
        dateFilter: new Date(),
        isOpen: false,
        workingCalendarForm: clone(defaultWorkingCalendarForm),
    },
    paths: {
        holidaysApprovalPath: "/api/cuentas/change-holidays-approval/",
        holidaysPath: "/api/cuentas/holidays/",
        wokingCalendarPath: "/api/cuentas/working-calendar/",
        getSpentHolidayPath: "/api/cuentas/working-calendar-get-spent-holidays/"
    }
}

const mutations = {
    holidaysFormType(state, val) {
        state.holidaysFormType = val
    },
    rangoDate(state, val) {
        state.rangoDate = val
    },
    selectedComercial(state, val) {
        state.selectedComercial = val
    },
    holidays: (state, val) => {
        state.holidays = clone(val)
    },
    isLoading: (state, val) => {
        state.isLoading = val
    },    
    isOpenHolidaysForm: (state, val) => {
        state.isOpenHolidaysForm = val
    },
    isOpenHolidaysDialog: (state, val) => {
        state.isOpenHolidaysDialog = val
    },
    holidaysForm: (state, val) => {
        state.holidaysForm = val
    },

    workingCalendarObj: (state, val) => {
        state.workingCalendarObj = val
    },
    workingCalendarDateFilter: (state, val) => {
        state.workingCalendarObj.dateFilter = val
    },
    workingCalendarIsOpen: (state, val) => {
        state.workingCalendarObj.isOpen = val
    },
    workingCalendar: (state, val) => {
        state.workingCalendarObj.workingCalendar = val
    },
    spentHolidays: (state, val) => {
        state.spentHolidays = val
    }
}

const actions = {
    async fetchHolidays({ commit, getters, state }, { start, end }) {
        commit('isLoading', true)
        let params = {
            range: [start.date, end.date]
        }
        if (state.selectedComercial) params = { ...params, commercial: state.selectedComercial.id }
        let { data } = await axios.get(getters.getEndpointFromPath(state.paths.holidaysPath),
            {
                params: params
            })
        commit("holidays", objectSnakeToCamelCase(data))
        commit('isLoading', false)
    },
    async deleteHoliday({ state, getters, dispatch, commit }, id) {
        try {
            commit('isLoading', true)
            let resp = await axios.delete(`${getters.getEndpointFromPath(state.paths.holidaysPath)}${id}/`)
            commit('isLoading', false)
			dispatch('fetchHolidays', state.rangoDate)
            dispatch('getSpentHolidays')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Holiday Borrado!",
            }, { root: true })
        } catch {
            commit('isLoading', false)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Borrar Vacaciones',
            }, { root: true })
        }
    },
    async changeHolidaysApproval({ getters, state, dispatch, commit }, id) {
        try {
            commit('isLoading', true)
            await axios.put(`${getters.getEndpointFromPath(state.paths.holidaysApprovalPath)}?id=${id}`)
            commit('isLoading', false)
			dispatch('fetchHolidays', state.rangoDate)
            dispatch('getSpentHolidays')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Vacaciones Editadas!",
            }, { root: true })
        } catch {
            commit('isLoading', false)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Editar Vacaciones',
            }, { root: true })
        }
    },
    async editHoliday({ getters, state, dispatch, commit }) {
        try {
            commit('isLoading', true)
            let formData = new FormData()
            for (let key in objectCamelToSnakeCase(clone(state.holidaysForm))) {
                if (state.holidaysForm[key] != null) {
                    formData.append(key, state.holidaysForm[key])
                }
            }

            await axios.put(`${getters.getEndpointFromPath(state.paths.holidaysPath)}${state.holidaysForm.id}/`, formData, {
                headers: { 
                    'Content-Type': 'multipart/form-data'
                }
            })
            commit('isLoading', false)
			dispatch('fetchHolidays', state.rangoDate)
            dispatch('getSpentHolidays')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Vacaciones Editadas!",
            }, { root: true })
        } catch {
            commit('isLoading', false)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al Editar Vacaciones',
            }, { root: true })
        }
    },
    async createHoliday({ getters, state, dispatch, commit }) {
        try {
            commit('isLoading', true)
            let formData = new FormData()
            for (let key in objectCamelToSnakeCase(clone(state.holidaysForm))) {
                if (state.holidaysForm[key] != null) {
                    if (typeof state.holidaysForm[key] === 'object' && state.holidaysForm[key].id) {
                        formData.append(key, state.holidaysForm[key].id)
                    } else {
                        formData.append(key, state.holidaysForm[key])
                    }
                }
            }

            await axios.post(getters.getEndpointFromPath(state.paths.holidaysPath), formData, {
                headers: { 
                    'Content-Type': 'multipart/form-data'
                }
            })
			commit('isLoading', false)
            dispatch('fetchHolidays', state.rangoDate)
            dispatch('getSpentHolidays')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Vacaciones Creadas!",
            }, { root: true })
        } catch {
            commit('isLoading', false)
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al crear Vacaciones',
            }, { root: true })
        }
    },
    async fetchWorkingCalendar({ getters, state, dispatch, commit }) {
        try {
            commit('isLoading', true)
            let { data } = await axios.get(getters.getEndpointFromPath(state.paths.wokingCalendarPath), {
                params: {
                    year: state.workingCalendarObj.dateFilter.getFullYear(),
                }
            })
            commit('workingCalendar', objectSnakeToCamelCase(data))
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al cargar calendario laboral',
            }, { root: true })
        }
        commit('isLoading', false)
    },
    async editWorkingCalendar({ getters, state, dispatch, commit }) {
        try {
            commit('isLoading', true)
            await axios.put(getters.getEndpointFromPath(state.paths.wokingCalendarPath), clone(state.workingCalendarObj.workingCalendar))
            dispatch('fetchWorkingCalendar')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Calendario Laboral Editado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al editar calendario laboral',
            }, { root: true })
        }
        commit('isLoading', false)
    },
    async createWorkingCalendar({ getters, state, dispatch, commit }) {
        try {
            commit('isLoading', true)
            await axios.post(getters.getEndpointFromPath(state.paths.wokingCalendarPath), clone(state.workingCalendarObj.workingCalendarForm))
            dispatch('fetchWorkingCalendar')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Día festivo creado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al crear día festivo',
            }, { root: true })
        }
        commit('isLoading', false)
    },
    async deleteWorkingCalendar({ getters, state, dispatch, commit }, id ) {
        try {
            commit('isLoading', true)
            await axios.delete(`${getters.getEndpointFromPath(state.paths.wokingCalendarPath)}${id}/`)
            dispatch('fetchWorkingCalendar')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: "Calendario Laboral Borrado!",
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al borrar calendario laboral',
            }, { root: true })
        }
        commit('isLoading', false)
    },
    async getSpentHolidays({ getters, state, dispatch, commit, rootGetters }, account ) {
        try {
            commit('isLoading', true)
            let id = null
            if (state.selectedComercial){
                id = state.selectedComercial.id
            } else {
                id = rootGetters['storage/getAccountParam'](account);
            }
            let { data } = await axios.get(getters.getEndpointFromPath(state.paths.getSpentHolidayPath), {
                params: {
                    account: id,
                }
            })
            commit('spentHolidays', data)
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'Error al obtener vacaciones gastadas',
            }, { root: true })
        }
        commit('isLoading', false)
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}